import { wtConfigProvider } from './wtConfigProvider';

export const msalConfig = [
    'msalAuthenticationServiceProvider',
    (msalProvider) => {
        const config = wtConfigProvider()?.azure;
        if (config) {
            msalProvider.init(config);
        }
    }
];
